<template>
  <div class="tab-content" :class="(!applyStatus.page.tab02.enable)?'app-lock':''">
    <el-form ref="form" :model="form" :rules="rules" label-position="top" :show-message="false">
      <el-form-item label="temp">
        <template slot="label">
          <label>銷售地區</label>
          <span class="hint">請選擇您希望銷售此應用程式的地區</span>
        </template>
        <el-checkbox-group v-model="marketIds">
          <el-checkbox
            v-for="m in marketList"
            :key="m.miboStoreMarketId"
            :label="m.miboStoreMarketId"
            @change="onMarketChecked"
          >{{ $t('botApp.' + m.name) }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="temp" prop="prices">
        <template slot="label">
          <label>{{t_content('botApp.tab02.isFree')}}</label>
        </template>
        <el-radio-group v-model="form.isFree" @change="handleIsFree">
          <el-radio label="Y">
            <div class="radio-label">{{t_content('botApp.tab02.free')}}</div>
          </el-radio>
          <br>
          <el-radio label="N">
            <div class="radio-label">{{t_content('botApp.tab02.charge')}}</div>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="activeteLock">
        <hr>
        <el-form-item label="temp">
          <template slot="label">
            <label>{{t_content('botApp.tab02.salePrice')}}</label>
          </template>
          <div v-for="(market,index) in availableMarketsSel" :key="index">
            <price-input :priceBox="displayPrice(market)" :fraction="getFraction(market)"/>
            <el-checkbox-group v-model="form.prices" style="display:none"></el-checkbox-group>
          </div>
        </el-form-item>
      </div>
      <hr v-show="!hideDate">
      <el-form-item label="temp" prop="publishBeginDate" v-show="!hideDate">
        <template slot="label">
          <label>{{t_content('botApp.tab02.publishType')}}</label>
          <br>
          <span class="hint">{{t_content('botApp.tab02.publishType.hint')}}</span>
        </template>
        <el-radio-group v-model="form.publishType">
          <el-radio label="auto" class="radio-label">{{t_content('botApp.tab02.auto')}}</el-radio>
          <br>
          <el-radio label="manual" class="radio-label">{{t_content('botApp.tab02.manual')}}</el-radio>
          <br>
          <el-radio label="candidate" class="radio-label">{{t_content('botApp.tab02.candidate')}}</el-radio>
          <br>
          <el-date-picker
            v-if="form.publishType=='candidate'"
            v-model="form.publishBeginDate"
            type="datetime"
            placeholder="Select date and time"
            style="margin:5px 1.8em"
          >
          </el-date-picker>
        </el-radio-group>
          <el-tooltip placement="top" effect="light"
          style="position:relative;left:0;top:40px;"
          >
          <template slot="content">
              <span v-html="t_content('botApp.tab02.publishType.date.tooltip')"></span>
          </template>
            <i class="el-icon-question"></i>
          </el-tooltip>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../../../api'
import apiConfig from '../../../api/apiConfig'
import _ from 'lodash'
import PriceInput from './tab02/priceInput'

export default {
    mounted () {
        let vm = this
        vm.initData()
    },
    data () {
        let {
            candidate,
            prices,
            // mainMarket,
            publishType,
            isFree,
            marketIds,
            publishBeginDate
        } = this.appInfo
        if (isFree === 'Y') {
            isFree = 'Y'
        }
        if (publishType === '') {
            publishType = 'auto'
        }
        var requiredbyPay = (rule, value, callback, label) => {
            let vm = this
            let emptyPrice = _.find(value, o => {
                return isNaN(o.price)
            })
            if (emptyPrice) {
                const errMsg =
                    label + ' ' + vm.$t('botApp.common.valid.required')
                vm.$store.state.botAppErrMessages.push(errMsg)
                callback(new Error('Please input the data'))
            } else {
                callback()
            }
        }
        var requiredbyDate = (rule, value, callback, label) => {
            let vm = this
            if (value === null && vm.form.publishType === 'candidate') {
                const errMsg =
                    label + ' ' + vm.$t('botApp.common.valid.required')
                vm.$store.state.botAppErrMessages.push(errMsg)
                callback(new Error('Please input the data'))
            } else {
                callback()
            }
        }
        return {
            candidate,
            marketList: [],
            currencyList: [],
            // mainMarket,
            marketIds,
            cloneMarketIds: marketIds.slice(0),
            dataLoaded: false,
            form: {
                isFree,
                prices,
                publishType,
                publishBeginDate
            },
            rules: {
                prices: [
                    {
                        validator: (rule, value, callback) =>
                            requiredbyPay(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab02.salePrice')
                            ),
                        trigger: 'blur'
                    }
                ], // []
                publishBeginDate: [
                    {
                        validator: (rule, value, callback) =>
                            requiredbyDate(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab02.publishBeginDate')
                            ),
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    props: ['appInfo', 'applyStatus', 'hideDate'],
    components: {
        'price-input': PriceInput
    },
    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        onMarketChecked (value) {
            if (!value) {
                this.$confirm(
                    this.t_content('botApp.common.delete.dialog.msg'),
                    this.t_content('botApp.common.delete.dialog.title'),
                    {
                        confirmButtonText: this.t_content('botApp.common.delete.dialog.ok'),
                        cancelButtonText: this.t_content('botApp.common.delete.dialog.cancel'),
                        type: 'warning'
                    }
                )
                    .then(() => {
                        this.cloneMarketIds = this.marketIds.slice(0)
                        this.form.prices = _.filter(this.form.prices, p => {
                            return (
                                this.marketIds.indexOf(p.miboStoreMarketId) > -1
                            )
                        })
                        this.$root.$emit('updateMarketIds', this.marketIds)
                    })
                    .catch(() => {
                        this.marketIds = this.cloneMarketIds.slice(0)
                    })
            } else {
                this.cloneMarketIds = this.marketIds.slice(0)
                this.$root.$emit('updateMarketIds', this.marketIds)
            }
        },
        getMarketbyLang (lang) {
            return _.find(this.marketList, { lang })
        },

        getDataFromChild () {
            this.form.prices = _.chain(this.form.prices)
                .filter(p => {
                    return this.marketIds.indexOf(p.miboStoreMarketId) > -1
                })
                .value()

            if (this.form.publishType !== 'candidate') {
                this.form.publishBeginDate = ''
            }

            return this.form
        },
        initData () {
            let vm = this
            Promise.all([vm.getMarketList(), vm.getCurrencyList()])
                .then(result => {
                    vm.marketList = result[0].data.data.payload
                    vm.currencyList = result[1].data.data.payload
                    // vm.meragePrices()
                    vm.dataLoaded = true
                })
                .catch(error => {
                    console.log(error)
                })
        },
        handleIsFree (value) {
            this.$root.$emit('isFreeChanged', value)
        },
        displayPrice (market) {
            // only show marketIds.
            // this.form.prices = _.filter(this.form.prices, p => {
            //     return this.marketIds.indexOf(p.miboStoreMarketId) > -1
            // })
            //
            let price = _.find(this.form.prices, {
                miboStoreMarketId: market.miboStoreMarketId
            })
            if (!price) {
                // if (!this.mainMarket) {
                //     if (this.marketIds.length > 0) {
                //         this.mainMarket = this.marketIds[0]
                //     }
                // }
                this.addPrice(market)
                price = _.find(this.form.prices, {
                    miboStoreMarketId: market.miboStoreMarketId
                })
            }
            return price
        },
        getFraction (market) {
            const cur = this.getCurrency(market.lang)
            return cur.fraction
        },

        getMarketbyId (miboStoreMarketId) {
            return _.find(this.marketList, { miboStoreMarketId })
        },
        addPrice (tgtMarket) {
            let mkt = this.marketList.find(market => {
                return market.miboStoreMarketId === tgtMarket.miboStoreMarketId
            })
            const cur = this.getCurrency(mkt.lang)
            this.form.prices.push({
                currency: this.getSymbol(cur.i18n).title + ' ' + cur.mark,
                price: 0,
                miboStoreMarketId: mkt.miboStoreMarketId,
                miboStoreLangId: mkt.miboStoreLangId,
                miboStoreCurrencyId: cur.miboStoreCurrencyId
            })
        },
        getMarketList () {
            const apiUri = 'developer/market'
            const apiCfg = apiConfig(apiUri)
            return api.request('get', apiCfg.path, null, null, apiCfg.headers)
        },
        getCurrencyList () {
            const apiUri = 'developer/currency'
            const apiCfg = apiConfig(apiUri)
            return api.request('get', apiCfg.path, null, null, apiCfg.headers)
        },
        getCurrency (langId) {
            return _.find(this.currencyList, o => o.lang === langId)
        },
        getSymbol (currencyI18n) {
            return _.find(currencyI18n, o => o.langCode === 'en')
        }
    },
    computed: {
        activeteLock () {
            return this.form.isFree === 'N' && this.dataLoaded
        },
        availableMarketsSel () {
            if (!this.marketList) return []
            return _.map(this.marketIds, mid => {
                return _.find(this.marketList, m => m.miboStoreMarketId === mid)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.radio-label {
    margin: 14px 0 0;
    display: inline-block;
}

.el-form-item {
    margin-bottom: 12px;
}
</style>
